export function getAllowedDeposits() {
  return {
    spot: ['USDT'],
    futures: ['USDT'],
  };
}

export function getAllowedNetworks() {
  return { spot: ['BSC'] };
}

export function getServiceCoins() {
  return ['USDT'];
}
